import axios from 'axios';
import { GeneratedReport, MonthlyReport, MonthlyReportSummary } from '../types';

const BASE = '/api/team-insights/reports';

export const listMonthlyReports = async (month: string): Promise<MonthlyReportSummary[]> => {
    const response = await axios.get<MonthlyReportSummary[]>(BASE, { params: { month } });
    return response.data;
};

export const getMonthlyReport = async (month: string, login: string): Promise<MonthlyReport> => {
    const response = await axios.get<MonthlyReport>(BASE, { params: { month, login } });
    return response.data;
};

export const generateMonthlyReport = async (
    month: string,
    login: string,
): Promise<GeneratedReport> => {
    const response = await axios.post<GeneratedReport>(`${BASE}/generate`, { month, login });
    return response.data;
};

export const saveMonthlyReport = async (
    month: string,
    login: string,
    content: string,
    generatedAt: string | null,
): Promise<MonthlyReport> => {
    const response = await axios.put<MonthlyReport>(BASE, { month, login, content, generatedAt });
    return response.data;
};
